import { render, staticRenderFns } from "./RequestUser.view.vue?vue&type=template&id=332ca44e&"
import script from "./RequestUser.view.vue?vue&type=script&lang=js&"
export * from "./RequestUser.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports